// candidateReducer.js
import { CANDIDATE_LOADING, CLEAR_CANDIDATE_LIST, GET_CANDIDATE_PROFILE_SUCCESS, GET_CANDIDATES_SUCCESS, SET_ASSESSMENT_INVITE_DETAILS, SET_VOICE_SESSION_DATA, SET_VIDEO_SESSION_DATA, CLEAR_CANDIDATE_PROFILE, GET_PREQUALIFYING_REPORT } from '../Types/types';

const initialState = {
  candidateList: [],
  pagination: { total: 0, page: 1, page_size: 10 },
  selectedCandidate: null,
  voiceSessionData: null,
  loading: false,
  assessmentInviteDetails: null,
  videoSessionData: null,
  preQualifyingReport: null,
};

const candidateReducer = (state = initialState, action) => {
  switch (action.type) {
    case CANDIDATE_LOADING:
      return { ...state, loading: action.payload };
    case GET_CANDIDATES_SUCCESS:
      return { ...state, candidateList: action.payload.data, pagination: action.payload.pagination, };
    case GET_CANDIDATE_PROFILE_SUCCESS: {
      const updatedCandidate = action.payload;
      return {
        ...state, selectedCandidate: updatedCandidate, candidateList: state.candidateList.map((c) => {
          if (c.id !== updatedCandidate.id) return c;
          const normalizedHiringStages =
            updatedCandidate.hiring_stages?.map((hs) => ({ ...hs, hiring_stage: hs.hiring_stage ?? c.hiring_stages?.find((old) => old.id === hs.id)?.hiring_stage ?? null, })) ?? c.hiring_stages;
          return { ...c, ...updatedCandidate, hiring_stages: normalizedHiringStages, };
        }
        ),
      };
    }
    case SET_VOICE_SESSION_DATA:
      return { ...state, voiceSessionData: action.payload };
    case SET_ASSESSMENT_INVITE_DETAILS:
      return { ...state, assessmentInviteDetails: action.payload };
    case SET_VIDEO_SESSION_DATA:
      return { ...state, videoSessionData: action.payload };
    case CLEAR_CANDIDATE_LIST:
      return { ...state, candidateList: [] };
    case CLEAR_CANDIDATE_PROFILE:
      return { ...state, selectedCandidate: null, voiceSessionData: null };
    case GET_PREQUALIFYING_REPORT:
      return { ...state, preQualifyingReport: action.payload };
    case "CLEAR_PREQUALIFYING_REPORT":
      return { ...state, preQualifyingReport: [] };
    default:
      return state;
  }
};
export default candidateReducer;
